import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Use it like this - https://stackblitz.com/edit/angular-v6amvy-pttrng?file=app%2Fcore%2Fmodal-window%2Fmodal-window.component.html
 * <ng-template #modalMail2smsaddressadd let-c="close" let-d="dismiss"><wsb-modal [primaryButtonFunction]="c" [dismissFunction]="d"
 * title="{{ 'settings_account_mail2sms_add_mail' | translate }}"></wsb-modal></ng-template>
 *   open(content: NgbModalRef) {
 *   this.modalService.open(content).result.then((result) => {
 *     this.closeResult = `Closed with: ${result}`;
 *   }, (reason) => {
 *     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
 *   });
 * }
 */

@Component({
  selector: 'wsb-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalComponent {
  // @ViewChild('modalBody', { static: true }) modalBody: ElementRef;
  // @ViewChild('modalFooter', { static: true }) modalFooter: ElementRef;
  @Input() public title;
  @Input() public text;
  @Input() public dismissButtonEnable = true;
  @Input() public cancelButtonEnable = false;
  @Input() public cancelButtonText = 'common_cancel';
  @Output() dismiss: EventEmitter<any> = new EventEmitter();
  @Input() public primaryButtonEnable = true;
  @Input() public loading = false;
  @Input() public primaryButtonText = 'common_ok';
  @Output() primary: EventEmitter<any> = new EventEmitter();
  @Input() extraFooterClasses = '';
  @Input() public disabledFooter = false;
  @Input() public primaryDisabled = false;

  constructor(public activeModal: NgbActiveModal) {}
}
